// Api.
import api from '../Base';

// Types.
import Agent from '../../types/instance/Agent';

const AgentApi = {

    getAgents: async () => {

        let url = `agent`;

        let agents: Agent[] = [];

        await api.get<Agent[]>(url)
            .then((response) => {
                agents = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve agents.', error);
            })
            .then(function () {});
        return agents;
    },

    getAgentCounts: async (agentId: number) => {
        const datasourceUrl = `datasource?full=true&agentid=${agentId}`;
        const hostUrl = `host?agentid=${agentId}`;

        let datasourceCount = 0;
        let hostCount = 0;

        // Fetch datasources count
        await api.get<any[]>(datasourceUrl)
            .then((response) => {
                datasourceCount = response.data.length;
            })
            .catch((error: any) => {
                console.error(`Failed to retrieve datasources for agent ${agentId}.`, error);
            });

        // Fetch hosts count
        await api.get<any[]>(hostUrl)
            .then((response) => {
                hostCount = response.data.length;
            })
            .catch((error: any) => {
                console.error(`Failed to retrieve hosts for agent ${agentId}.`, error);
            });

        return { datasourceCount, hostCount };
    },

    createAgent: async (agent: Partial<Agent>) => {
        let url = `agent`;
        return api.post(url, [agent]);
    },

    updateAgent: async (agent: Agent) => {
        let url = `agent`;
        return api.put(url, [agent]);
    },

    deleteAgent: async (agent: Agent) => {
        let url = `agent`;
        return api.delete(url, { data: [agent] });
    }
}

export default AgentApi;